module.exports = __webpack_public_path__ + "static/media/graph.f2f31c6f.png";